import React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import { baseURL } from "store/services/base.config";
import useLocalizationStore from "store/zustand/localization";

const UserProfile = ({ customer, direction = "ltr", full_name, secondary }) => {
  const { language } = useLocalizationStore();
  const getInitials = (fullName) => {
    const nameParts = fullName?.split(" ") || [];
    const initials =
      nameParts.length >= 2
        ? `${nameParts[0][0]}${nameParts[1][0]}`
        : nameParts[0][0];
    return initials.toUpperCase();
  };

  const avatarSrc =
    customer?.avatar ||
    (customer?.profile_image ? `${baseURL}${customer.profile_image}` : "") ||
    (customer?.user?.profile_image ? `${baseURL}${customer.user.profile_image}` : "") ||
    (customer?.image ? `${baseURL}${customer.image}` : "");

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      width={150}
      flexDirection={direction}
      textAlign={language === "ar" ? "right" : "left"}
    >
      <Avatar src={avatarSrc || undefined}>
        {!customer?.profile_image &&
          !customer?.user?.profile_image &&
          !customer?.avatar &&
          getInitials(full_name ? full_name : customer?.full_name)}
      </Avatar>
      <Box>
        <Typography variant="subtitle2" fontWeight={600}>
          {full_name ? full_name : customer?.full_name}
        </Typography>
        {secondary && (
          <Typography variant="subtitle2" color="text.secondary">
            {secondary ? secondary : customer?.email}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default UserProfile;
